import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader

// custom icons
import IconAccount from '@/components/Icons/IconAccount.vue';
import IconChevronDown from '@/components/Icons/IconChevronDown.vue';
import IconList from '@/components/Icons/IconList.vue';
import IconMoon from '@/components/Icons/IconMoon.vue';
import IconNewTask from '@/components/Icons/IconNewTask.vue';
import IconRotate from '@/components/Icons/IconRotate.vue';
import IconSun from '@/components/Icons/IconSun.vue';
import IconTrash from '@/components/Icons/IconTrash.vue';

const isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

Vue.use(Vuetify);
export default new Vuetify({
  theme: {
    dark: process.env.NODE_ENV === 'development' ? isDarkMode : false,
    options: {
      customProperties: true,
    },
    themes: {
      // keep in sync with src/assets/styles/sourcery.scss
      light: {
        blue: '#2479ff',
        yellow: '#F06F00',
        green: '#00a774',
        red: '#da304c',
        black: '#0C0C0C',
        white: '#FEFEFE',
        lightGrey: '#F7F7F9',
        darkGrey: '#ACACAC',
        // TODO: remove colors below
        // grey and error--text are still used please check
        lightBlack: '#171E37',
      },
      dark: {
        blue: '#2479ff',
        yellow: '#F06F00',
        green: '#00a774',
        red: '#da304c',
        black: '#FEFEFE',
        white: '#0C0C0C',
        lightGrey: '#22262A',
        darkGrey: '#F7F7F9',
        lightBlack: '#171E37',
      },
    },
  },
  breakpoint: {
    mobileBreakpoint: 992,
    // this defines the max-width of a breakpoint
    // keep in sync with $grid-breakpoints variables
    // inside src/styles/variables.scss
    thresholds: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1280,
      xl: 1600,
    },
    scrollBarWidth: 0,
  },
  icons: {
    iconfont: 'md',
    values: {
      account: {
        component: IconAccount,
      },
      chevronDown: {
        component: IconChevronDown,
      },
      list: {
        component: IconList,
      },
      moon: {
        component: IconMoon,
      },
      newTask: {
        component: IconNewTask,
      },
      rotate: {
        component: IconRotate,
      },
      sun: {
        component: IconSun,
      },
      trash: {
        component: IconTrash,
      },
    },
  },
});
